export interface ProductPresentation {
  routeBase: string;
  description: string;
}

const PRODUCT_PRESENTATIONS: readonly ProductPresentation[] = Object.freeze([
  Object.freeze({
    routeBase: "commerce",
    description: "Creá tu tienda, administrá productos y variantes desde el espacio privado de tu organización.",
  }),
  Object.freeze({
    routeBase: "reputation",
    description: "Gestioná reseñas, respuestas y reputación desde un solo lugar.",
  }),
  Object.freeze({
    routeBase: "salons",
    description: "Conversaciones, agenda, clientes, ventas y operación diaria.",
  }),
  Object.freeze({
    routeBase: "menu",
    description: "Gestioná la carta digital y la experiencia de menú del negocio.",
  }),
  Object.freeze({
    routeBase: "custom",
    description: "Accedé a la aplicación personalizada configurada para este negocio.",
  }),
]);

const presentationByRoute = new Map(
  PRODUCT_PRESENTATIONS.map((presentation) => [presentation.routeBase, presentation] as const),
);

export function productPresentationForRouteBase(routeBase: string): ProductPresentation {
  return presentationByRoute.get(routeBase) ?? {
    routeBase,
    description: "Accedé a la solución ClickDialog configurada para este negocio.",
  };
}
